import { UIMatch, useLocation, useMatches } from "react-router-dom";

export function useMatch<T>(): UIMatch<unknown, T> {
  const location = useLocation();
  const matches = useMatches();

  return matches.findLast(
    (match) => match.pathname === location.pathname
  ) as UIMatch<unknown, T>;
}
